module.exports = __webpack_public_path__ + "assets/images/plus_gray.svg?0e0f1b28ed1dbee1cff157998b0fc851";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/plus_gray.svg
// module id = 606
// module chunks = 0